import type { ComponentProps } from "react";
import { cn } from "./cn";

const control =
  "w-full rounded-md border border-line-strong bg-surface px-2.5 text-sm text-fg placeholder:text-subtle disabled:cursor-not-allowed disabled:opacity-60 aria-[invalid=true]:border-danger";

export function Input({ className, ...props }: ComponentProps<"input">) {
  return <input className={cn(control, "h-8", className)} {...props} />;
}

export function Textarea({ className, ...props }: ComponentProps<"textarea">) {
  return <textarea className={cn(control, "min-h-20 py-1.5", className)} {...props} />;
}

/** Native select: accessible by default, dense, works with every assistive technology. */
export function NativeSelect({ className, ...props }: ComponentProps<"select">) {
  return <select className={cn(control, "h-8 pr-7", className)} {...props} />;
}
